module.exports = __webpack_public_path__ + "static/media/git-process.f6a5fd17.png";